<template>
    <main id="content" class="sma-about-content">
        <div class="container">
            <div class="link-page">
                <div class="breacrump">
                    <div
                        class="item-breacrump"
                        itemscope
                        itemtype="http://data-vocabulary.org/Breadcrumb"
                    >
                        <router-link to="/" class="link-home">
                            <span itemprop="title">{{ $t("app.Home") }}</span>
                        </router-link>
                        <span class="slashes-link">/</span>
                    </div>
                    <div
                        class="item-breacrump"
                        itemscope
                        itemtype="http://data-vocabulary.org/Breadcrumb"
                    >
                        <router-link to="/blog">
                            <span itemprop="title">{{ $t("app.Blog") }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
            <FeaturedBlog />
            <div class="list-slider-blog" v-if="blogs.length">
                <BlogSlide
                    v-for="(blog, index) in blogs"
                    :key="index"
                    :blog="blog"
                />
            </div>
        </div>
    </main>
</template>
<script>
import FeaturedBlog from "@/components/FeaturedBlog";
import BlogSlide from "@/components/BlogSlide";
import { mapActions, mapState } from "vuex";
import { get } from "lodash";
import { setDescriptionPage } from "@/helper/helper";
const colors = ["#4392F1", "#E55934", "#FBB13C"];
export default {
    components: {
        FeaturedBlog,
        BlogSlide
    },
    mounted() {
        this.getBlogs();
        setDescriptionPage(get(this.general, "blog_page_metades"));
    },
    computed: {
        ...mapState({
            general: state => get(state, "app.general", {}),
            blogs: state =>
                get(state, "blogs.list", [])
                    .filter(item => item.name !== "Featured Blogs")
                    .map(item => ({
                        ...item,
                        color: colors[Math.floor(Math.random() * colors.length)]
                    }))
        })
    },
    methods: {
        ...mapActions("blogs", ["getBlogs"])
    }
};
</script>
